import { Injectable, InjectionToken } from '@angular/core';
import { Observable, of } from 'rxjs';

export interface LoggedInUserInfo {
  salespersonId: string;
  isImpersonation: boolean;
  hasAccessToAllAccountsInMarket: boolean;
  partnerId: string;
  marketId: string;
  phoneExtension: string;
  userName: string;
  salesManagerId?: string;
}

export interface LoggedInUserInfoServiceInterface {
  loggedInUserInfo$: Observable<LoggedInUserInfo>;
  hasAccessToAllAccountsInMarket$: Observable<boolean>;
  salesPersonId$: Observable<string>;

  getPartnerId(): Observable<string>;

  getMarketId(): Observable<string>;
}

export const LoggedInUserInfoServiceInterfaceToken: InjectionToken<LoggedInUserInfoServiceInterface> =
  new InjectionToken<LoggedInUserInfoServiceInterface>('LoggedInUserInfoServiceInterface');

@Injectable()
export class LoggedInUserInfoServiceInterfaceStub implements LoggedInUserInfoServiceInterface {
  loggedInUserInfo$: Observable<LoggedInUserInfo> = of({
    salespersonId: 'SP-1',
    isImpersonation: false,
    hasAccessToAllAccountsInMarket: true,
    partnerId: 'ABC',
    marketId: 'mk1',
    phoneExtension: '555',
    userName: 'John Doe',
  });
  hasAccessToAllAccountsInMarket$: Observable<boolean> = of(true);
  salesPersonId$: Observable<string> = of('SP-1');

  getPartnerId(): Observable<string> {
    return of('ABC');
  }

  getMarketId(): Observable<string> {
    return of('mk1');
  }
}
